export default __webpack_public_path__ + "static/media/fact_sheet27.7ac56393.png";